<template>
	<div class="demand">
		<header>
            <Header />
        </header>
		<main>
            <!-- demand search -->
            <section class="demand-grid">
                <div class="container demand-grid-container" >
                    <div class="row ">
                        <div class="col-12 col-xl-12">
                            <el-input placeholder="搜索资源需求名称" class="handle-input" v-model="header.requireTitle" clearable></el-input>
                            <el-button type="primary" class="mt-2" icon="el-icon-search" @click="getListData">搜索</el-button>
                        </div>
                        <div class="col-12 col-xl-12 mt-2 demand-grid-item">
                            <div class="demand-item-title">发布时间:</div>
                            <el-date-picker
                                @change="getListData"
                                v-model="header.time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                            
                        </div>
                    </div>
                </div>
            </section>
            <section class="demand-list">
                <div class="container">
                    <div class="row">
                        <!-- 左侧 需求分类 -->
                        <div class="col-xl-3 col-12 demand-wrapper-left">
                            <div class="wrapper-left-title">需求分类</div>
                            <div class="wrapper-left-tab">
                                <div class="left-tab-item" :class="{'active':tabNum ==  index+1}" v-for="(item,index) in leftTabList" :key="index" @click="handleTabClick(index+1)">
                                    <div>{{ item.label }}</div>
                                    <div><i class="el-icon-arrow-right"></i></div>
                                </div>
                            </div>
                        </div>
                        <!-- 右侧 需求内容 -->
                        <div class="col-xl-9 col-12  demand-wrapper-right">
                            <div class="row demand-right-data">
                                <div class="col-12 col-xl-4 right-data-item" v-for="(item,index) in listData" :key="index" @click="handleDetail(item)">
                                    <div class="right-item">
                                        <div class="data-item-title">{{item.requireTitle}}</div>
                                        <div class="data-item-desc">{{ item.requireDesc }}</div>
                                        <div class="data-item-card">{{ item.requireLabel }}</div>
                                        <div class="data-item-time">发布时间: <span>{{ item.insertTime }}</span></div>
                                        <div class="data-item-budget">预算范围: <span>{{ item.budget }}</span></div>
                                    </div>
                                </div>
                                <div v-if="listData.length == 0" style="background-color:#fff" class="col-12 mb-2">
                                    <el-empty description="暂无数据"></el-empty>
                                </div>
                                <div class="pagination">
                                    <el-pagination
                                        background
                                        @current-change="handleCurrentChange"
                                        :current-page="query.pageIndex"
                                        :page-size="query.pageSize"
                                        layout="total, prev, pager, next, jumper"
                                        :total="query.total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 详情 -->
            <el-dialog :visible.sync="isVisibleDemandData" width="700px" >
                <el-descriptions title="资源需求详情" direction="vertical" :column="1" border :labelStyle="{'text-align':'center','font-size':'15px'}" :contentStyle="{'text-align':'center','font-size':'13px'}">
                    <el-descriptions-item label="资源需求标题">{{ demandData.requireTitle }}</el-descriptions-item>
                    <el-descriptions-item label="资源需求标签">{{ demandData.requireLabel }}</el-descriptions-item>
                    <el-descriptions-item label="资源预算">{{ demandData.budget }}</el-descriptions-item>
                    <el-descriptions-item label="联系人">{{ demandData.linkName }}</el-descriptions-item>
                    <el-descriptions-item label="联系电话">{{ demandData.linkPhone }}</el-descriptions-item>
                    <el-descriptions-item label="资源需求描述">{{ demandData.requireDesc }}</el-descriptions-item>
                    <el-descriptions-item label="备注">{{ demandData.remark }}</el-descriptions-item>

                </el-descriptions>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="isVisibleDemandData = false">关 闭</el-button>
                </div>
            </el-dialog>
		</main>
		<!-- <footer><Footer /></footer> -->
	</div>
</template>

<script>
import {
    demandMarketList,
    demandMarketDetail,
} from '@/api/index'
import Header from '../../components/header.vue';
// import Footer from '../../components/footer.vue';
export default {
  	name: 'Home',
	components: {
		Header,
		// Footer
	},
	data() {
		return {
            header:{
                requireTitle:"",
                time:"",
            },
            tabNum:"1",
            leftTabList:[
                {value: 'GPU 算力服务', label: 'GPU 算力服务'},
                // {value: 'CPU 算力服务', label: 'CPU 算力服务'},
                // {value: '存储服务', label: '存储服务'},	
                // {value: '硬件资源', label: '硬件资源'},
                // {value: '云主机', label: '云主机'},
            ],
            
            listData:[],
            query:{
                pageIndex:1,
                pageSize:10,
                total:0,
            },
            isVisibleDemandData :false,
            demandData:{},
		};
		
		
	},
	mounted() {
        this.getListData();
	},
    methods:{
        async getListData(){
            let param = {
				pageNum:this.query.pageIndex,
				pageSize:this.query.pageSize,
				requireTitle:this.header.requireTitle,//需求标题
				startDate:this.header.time[0],//开始时间
				endDate :this.header.time[1],//结束时间
			}
            let res = await demandMarketList(param);
            if(res.success){
                this.listData = res.data.records;
                this.query.total = res.data.total;
            }
        },
        handleCurrentChange(val) {
            this.query.pageIndex = val;
            this.getListData();
        },
        async handleDetail(row){
            //小屏幕时弹出提示框
			let screenWidth = window.innerWidth;
			let flag = this.$myGlobalMethods(screenWidth)
			if(flag){
				return;
			}
            const resData = await demandMarketDetail(row.id);
            this.demandData = {};
            if(resData.success){
                this.demandData = resData.data;
                this.isVisibleDemandData = true;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.demand{
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    width:100%;
    height:100%;
    background-color: #f9fafb;
}
header {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.2rem 0.6rem 0 #0000001a;
    position: sticky;
    top: 0;
    z-index: 99;
}

.demand-grid{
    width: 100%;
    height:auto;
    padding:20px 0 20px;
	// 
    .demand-grid-container{
        box-sizing:border-box;
        padding:20px 20px;
        background-color: #fff;
    }
    .demand-grid-item{
        display:inline-block;
        width:auto;
        margin-top:10px;
        margin-right:20px;
        .demand-item-title{
            display:inline-block;
            font-size:14px;
            font-weight:500;
            vertical-align: middle;
            color:#4b5563;
            margin-right:10px;
        }
        
    }
}
.demand-list{
    width: 100%;
    height:auto;
    // margin-top:20px;
	background-color: #f9fafb;
    
    .demand-wrapper-left{
        // width:15%;
        height:auto;
        max-height:130px;
        margin-top:20px;
        border-radius:5px;
        background-color:#fff;
        box-sizing:border-box;
        padding:10px 20px;
        .wrapper-left-title{
            width:100%;
            height:2rem;
            line-height:2rem;
            font-size:0.8rem;
            letter-spacing: 1px;
            border-bottom:1px solid #e5e7eb;
        }
        .wrapper-left-tab{
            width:100%;
            height:auto;
            margin:10px 0;
            .left-tab-item{
                width: 100%;
                height:2rem;
                line-height:2rem;
                box-sizing: border-box;
                padding:0 0.5rem;
                font-size:0.8rem;
                display: flex;
                justify-content: space-between;
            }
            .left-tab-item:hover{
                color:#106eea;
                cursor: pointer;
                background-color: #f9fafb;
            }
            .left-tab-item.active{
                color:#409EFF;
                background-color: #dbeafe;
            }
        }
    }

    .demand-wrapper-right{
        // margin-left: 10px;
        margin-top:20px;
        .demand-right-data{
            width:100%;
            height:auto;
            .right-data-item{
                box-sizing: border-box;
                padding:0 10px;
                .right-item{
                    margin-bottom:20px;
                    min-height:270px;
                    box-sizing: border-box;
                    padding:10px 20px;
                    border-radius:10px;
                    background-color:#fff;
                    .data-item-title{
                        width:100%;
                        height:30px;
                        height:30px;
                        line-height:30px;
                        font-size:16px;
                        font-weight:600;
                        color:#000;
                        
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .data-item-desc{
                        min-height:50px;
                        margin:20px 0;
                        font-size:13px;
                        color:#666;
                        display: -webkit-box;
                        -webkit-line-clamp: 3; 
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .data-item-card{
                        width:100px;
                        height:30px;
                        margin-top:10px;
                        text-align:center;
                        line-height:30px;
                        font-size:13px;
                        border-radius:5px;
                        color:#0066ff;
                        background-color: #dbeafe;
                    }
                    .data-item-time{
                        margin-top:10px;
                        color:#999;
                        font-size:15px;
                    }
                    .data-item-budget{
                        margin-top:10px;
                        font-size:17px;
                        font-weight:600;
                        color:#0066ff;
                    }
                }
                .right-item:hover{
                    cursor: pointer;
                    box-shadow: 0 2px 8px 0 rgba(0,0,0,.1);
                }
            }
            
        }
    }
    
}
</style>

<style  scoped>
.handle-input{
    max-width:600px;
    margin-right:10px;
}
</style>
